import { useTranslation } from 'react-i18next'

export const SIZE_UNIT = 'MB'

export const useExtensionsString = (extensions: string[]) => {
  const { t } = useTranslation()
  const mapped = extensions.map(ext => `.${ext}`)
  const length = extensions.length
  if (!length) return ''
  if (length === 1) return `.${extensions[0]}`
  return [[...mapped].slice(0, length - 1).join(', '), mapped[length - 1]].join(
    ` ${t('or')} `
  )
}
